export const environment = {
  production: true,
  envName: 'prod',
  envURL_API_CLAVES:'https://directorio.ucuenca.edu.ec/ms/reestablecer-contrasenas/api'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts